import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { getTrailUserById } from "../../api/trialUsers";
import ViewTrialUser from "./trial.user.view";
import { handleAxiosError } from "../../config/action-config";
const emptyTrailUserData = {
  email: "",
  firstname: "",
  lastname: "",
  contact: "",
  address: "",
  company: "",
};

export default function ViewCustomTrailUser() {
  const user = useSelector((state) => state.user);
  const [data, setData] = useState(null);
  const params = useParams();
  const dispatch = useDispatch();

  useEffect(() => {
    if (!params.id) {
    } else {
      loadMasterData();
    }
  }, [params.id]);
  async function loadMasterData() {
    try {
      const { data } = await getTrailUserById(params.id, user.token);
      setData(data.data.User);
    } catch (error) {
      handleAxiosError(error, dispatch);
    }
  }
  return data ? (
    <ViewTrialUser preloadedValues={data} refresh={loadMasterData} />
  ) : (
    <div className="center">Loading.....</div>
  );
}
